var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"9","height":"9","fill":"none"}},[_c('circle',{attrs:{"cx":"4.5","cy":"4.5","r":"4.5","fill":"#E85C20"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }